/* eslint-disable */
import React, { useRef, useState, useEffect } from 'react'
import {
  faEye,
  faEyeSlash,
  faCircleExclamation,
  faCheck,
  faTimes,
  faCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import bg from '../img/forgot-password-page.png'
import mobile from '../img/mobile-forgot-pass.png'
import moblink from '../img/mobile-resetlink.png'
import link from '../img/password-reset-link.png'
import { Link } from 'react-router-dom'
import axios from '../api/axios'
import logo from '../img/swb-logo-heart.png'

const ForgotPassword = () => {
  const emailRef = useRef()
  const errRef = useRef()

  const [email, setEmail] = useState('')
  const [validEmail, setValidEmail] = useState(false)
  const [emailFocus, setEmailFocus] = useState(false)

  const [errMsg, setErrMsg] = useState('')
  const [success, setSuccess] = useState(false)

  const EMAIL_REGEX =
    /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,12})$/
  const FORGOT_PWD_URL = '/forgot-password'

  useEffect(() => {
    setValidEmail(EMAIL_REGEX.test(email))
  }, [email])

  useEffect(() => {
    setErrMsg('')
  }, [email])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!EMAIL_REGEX.test(email)) {
      setErrMsg('Please enter a valid email address')
      return
    }

    try {
      const response = await axios.post(FORGOT_PWD_URL, { email })

      if (response.data?.error) {
        setErrMsg(response.data.message || 'An error occurred')
        return
      }

      setSuccess(true)
    } catch (error) {
      if (!error?.response) {
        setErrMsg('No Server Response')
      } else if (error.response?.status === 422) {
        setErrMsg('No user found with this email address.')
      } else {
        setErrMsg('Error occurred. Could not generate link.')
      }
    }
  }

  return (
    <div
      className="min-h-screen bg-cover bg-center px-8 relative"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="md:flex md:items-center md:justify-between">
        <div className="absolute top-[18%] left-0 md:left-[10%] max-w-xl w-full mx-auto">
          {/* Inner container with background via ::before */}
          <div
            className="relative px-4 pb-8 md:p-8 space-y-4 md:space-y-6 
              bg-white/90 shadow-lg rounded-lg
                        lg:bg-transparent lg:shadow-none lg:opacity-100"
          >
            <div className="relative z-10">
              <div className="pt-16 md:pt-0 flex items-center gap-3 pb-2 leading-tight tracking-wider text-[#360F41] dark:text-white">
                <img src={logo} alt="SWB Logo" className="h-20 w-auto" />
                <div>
                  <h1 className="text-2xl md:text-3xl font-bold">
                    School Wellbeing Staff Portal
                  </h1>
                </div>
              </div>
              <h2 className="text-base md:text-xl font-medium text-center">
                Forgot Password
              </h2>
            </div>

            {!success ? (
              <form
                onSubmit={handleSubmit}
                className="space-y-4 md:space-y-6 w-full relative z-10"
              >
                <div className="md:w-2/3 mx-auto">
                  {/* Hidden username input for accessibility */}
                  <input
                    type="text"
                    name="username"
                    autoComplete="username"
                    className="hidden"
                  />

                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-medium text-gray-700 dark:text-white z-50"
                  >
                    Email <span className="text-rose-500"> *</span>
                  </label>
                  <input
                    type="email"
                    ref={emailRef}
                    id="email"
                    onChange={(e) => setEmail(e.target.value)}
                    onFocus={() => setEmailFocus(true)}
                    onBlur={() => setEmailFocus(false)}
                    required
                    placeholder="Please enter your email address"
                    className="z-50 bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:outline-none focus:border-violet-300 focus:ring-1 focus:ring-violet-300 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  />
                  <p
                    id="emailnote"
                    className={
                      email && emailFocus && !validEmail
                        ? 'visible mt-2 text-xs text-rose-500'
                        : 'hidden'
                    }
                  >
                    <FontAwesomeIcon
                      icon={faCircleExclamation}
                      className="mr-1"
                    />
                    Invalid email address.
                  </p>

                  {errMsg && (
                    <p
                      ref={errRef}
                      className="bg-red-100 text-red-700 border border-red-400 rounded-md px-4 py-2 text-sm text-center mt-4"
                      aria-live="assertive"
                    >
                      {errMsg}
                    </p>
                  )}

                  <div className="mt-4 text-wba-primary text-xs flex justify-center z-50">
                    <Link to="/login" className="hover:text-blue-800">
                      Back to Login
                    </Link>
                  </div>

                  <div>
                    <input
                      type="submit"
                      disabled={!validEmail}
                      value="Reset Password"
                      className={`text-white relative z-10 hover:bg-hub-primary-hover text-center py-2 w-full rounded-md mt-2 
                                    ${
                                      !validEmail
                                        ? 'cursor-not-allowed bg-gray-600'
                                        : 'cursor-pointer bg-hub-primary'
                                    }`}
                    />
                  </div>
                </div>
              </form>
            ) : (
              <div className="lg:pl-16 relative z-10">
                <div className="text-center">
                  <div className="text-lg">
                    The password reset link has been sent
                  </div>
                  <div className="text-sm">Please check your emails.</div>
                  <div className="mt-4 text-wba-primary text-xs flex justify-center z-50">
                    <Link to="/login" className="hover:text-blue-800">
                      Back to Login
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
